// @vue/component
import {useStrategyDetailsStore} from "@/stores/CrossWalkAnalysis/strategyDetails";
import {storeToRefs} from "pinia";
import { MDBBtn, MDBTooltip } from 'mdb-vue-ui-kit';
import { ref } from 'vue';
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faPlus } from '@fortawesome/free-solid-svg-icons'
library.add(faPlus)
import { faMinus } from '@fortawesome/free-solid-svg-icons'
import {useCrosswalkChallengeStore} from "@/stores/CrossWalkAnalysis/challenge";
library.add(faMinus)

export default {
  name: 'SingleStrategySetup',

  components: {MDBBtn, MDBTooltip, FontAwesomeIcon},

  mixins: [],

  props: {},

  setup() {
    const strategyDetailsStore = useStrategyDetailsStore()
    const challengeStore = useCrosswalkChallengeStore()

    const { allStrategyDetails } =  storeToRefs(strategyDetailsStore)
    const removesubtooltip = ref([[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[]]);
    const addsubtooltip = ref([]);
    const removetooltip = ref([]);
    const addtooltip = ref(false);
    const strategy = ref(strategyDetailsStore.allStrategyDetails[strategyDetailsStore.setupStrategyId]);
    const { setupStrategyId } =  storeToRefs(strategyDetailsStore)
    const { editMode } =  storeToRefs(challengeStore)

    return { strategyDetailsStore, allStrategyDetails, removesubtooltip, addsubtooltip, removetooltip, addtooltip, strategy, setupStrategyId, editMode}

  },

  data () {
    return {

    }
  },

  computed: {
    keyword(strategyId) {
      return this.strategyDetailsStore.allStrategyDetails[strategyId]?.keyword
    }

  },

  watch: {},

  mounted () {
    this.strategyDetailsStore.fetchCrosswalkAnalysis()
    this.strategy = this.strategyDetailsStore.allStrategyDetails[this.strategyDetailsStore.setupStrategyId]
    //console.log("strategy:")
    //console.log(this.strategy)

  },

  methods: {
    onOrderChanged() {
      const arr = this.strategyDetailsStore.allStrategyDetails || []
      const movedIdx = this.strategyDetailsStore.setupStrategyId
      if (arr[movedIdx] == null) return

      // desired order comes from the dropdown (already bound via v-model.number)
      const desiredOrder = arr[movedIdx].order
      this.applyOrderChange(movedIdx, desiredOrder)

      this.strategyDetailsStore.allStrategyDetailsChanged?.()
    },

    // Insert the edited item at the requested slot, then renumber 1..N
    applyOrderChange(movedIdx, desiredOrder) {
      const arr = this.strategyDetailsStore.allStrategyDetails || []
      const n = arr.length
      if (n <= 1) return

      // Build a stable sequence of indices sorted by current order (fallback to i+1)
      const seq = arr.map((s, i) => ({ i, order: (s.order ?? (i + 1)) }))
          .sort((a, b) => (a.order === b.order) ? a.i - b.i : a.order - b.order)

      // Clamp target position
      const targetPos = Math.min(Math.max(1, parseInt(desiredOrder, 10) || 1), n) - 1

      // Remove the moved item from the sequence
      const fromPos = seq.findIndex(p => p.i === movedIdx)
      if (fromPos === -1) return
      const [moved] = seq.splice(fromPos, 1)

      // Insert at the desired position
      seq.splice(targetPos, 0, moved)

      // Renumber orders to be unique and sequential
      seq.forEach((p, idx) => {
        arr[p.i].order = idx + 1
      })
    },
    normalizeStrategyOrders() {
      const arr = this.strategyDetailsStore.allStrategyDetails || []
      if (!arr.length) return
      const stable = arr.map((s, i) => ({ s, i }))
          .sort((a, b) => {
            const ao = a.s.order ?? 1e9, bo = b.s.order ?? 1e9
            if (ao !== bo) return ao - bo
            return a.i - b.i
          })
      stable.forEach((wrap, idx) => { wrap.s.order = idx + 1 })
    },
    addSubStrategy(strategyIndex) {
      if (this.allStrategyDetails[strategyIndex] == null) {
        this.allStrategyDetails[strategyIndex] = {name:"", subStrategies: []}
      }
      this.allStrategyDetails[strategyIndex].subStrategies.push({name:""})
      this.strategyDetailsStore.allStrategyDetailsChanged()
    },
    removeSubStrategy(strategyIndex, subStrategyIndex) {
      //console.log( this.allStrategyDetails[strategyIndex].subStrategies);
      //console.log("")
      this.allStrategyDetails[strategyIndex].subStrategies.splice(subStrategyIndex,1);
      this.strategyDetailsStore.allStrategyDetailsChanged()
    },
    clickRemoveStrategy() {
      //console.log("removing...")
      //console.log(this.allStrategyDetails)
      //console.log(this.setupStrategyId)
      this.allStrategyDetails.splice(this.setupStrategyId,1);
      this.strategyDetailsStore.allStrategyDetailsChanged()
    },
  }
}
